var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGithubGitIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16_1061)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.029 8.34497C18.759 8.34497 8 19.104 8 32.378C8 42.995 14.885 52.002 24.435 55.181C25.637 55.401 26.075 54.659 26.075 54.021C26.075 53.452 26.055 51.94 26.043 49.935C19.358 51.387 17.948 46.713 17.948 46.713C16.855 43.938 15.279 43.199 15.279 43.199C13.097 41.707 15.444 41.737 15.444 41.737C17.856 41.908 19.125 44.214 19.125 44.214C21.269 47.886 24.75 46.825 26.119 46.211C26.338 44.658 26.957 43.599 27.645 42.998C22.309 42.392 16.698 40.329 16.698 31.121C16.698 28.498 17.635 26.352 19.172 24.672C18.925 24.064 18.1 21.621 19.407 18.312C19.407 18.312 21.425 17.666 26.016 20.776C27.933 20.243 29.989 19.976 32.032 19.967C34.073 19.976 36.129 20.243 38.049 20.776C42.637 17.666 44.651 18.312 44.651 18.312C45.962 21.621 45.137 24.064 44.89 24.672C46.43 26.352 47.361 28.498 47.361 31.121C47.361 40.353 41.741 42.384 36.387 42.979C37.251 43.721 38.019 45.187 38.019 47.43C38.019 50.642 37.99 53.234 37.99 54.021C37.99 54.665 38.422 55.413 39.642 55.178C49.184 51.993 56.063 42.992 56.063 32.378C56.063 19.104 45.303 8.34497 32.029 8.34497Z",
    fill: "#010101"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16_1061"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithubGitIcon);
export default __webpack_public_path__ + "static/media/github_git_icon.f560a0132fe350f7d70fe4e7dd6ee736.svg";
export { ForwardRef as ReactComponent };